module.exports = __webpack_public_path__ + "img/brand-4.4324f0fe.png";